import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Autocomplete, TextField, Button, Paper, Dialog, Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetSaleReportsMutation } from '../../services/reports';
import { useSaveImportStatusMutation } from '../../services/product';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import XLSX from 'xlsx-js-style';//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { QRCodeSVG, QRCodeCanvas } from 'qrcode.react';
import ImportExcel from './importExcel';

const API_URI = process.env.REACT_APP_API_URI;

export default function InternalTransfer() {
  const [getSaleReports, saleReportsResult] = useGetSaleReportsMutation();
  const [saveImportStatus] = useSaveImportStatusMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [openOtp, setOpenOtp] = useState(false);
  const [qrSrc, setQrSrc] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const [userId, setUserId] = useState(0);
  const [openImport, setOpenImport] = useState(false);
  const [priority, setPriority] = useState([]);
  const gridRef = useRef();
  const fileInputRef = useRef(null);

  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
        { make: 'Total', model: '', Qty: 0 }
    ]);

  ModuleRegistry.registerModules([ AllCommunityModule ]);
  useEffect(() => {
    const uId = JSON.parse(window.localStorage.getItem("user"))?.id;
    setUserId(uId);

    handleGridHeight();

    window.addEventListener("resize", handleGridHeight);
    return () => {
      window.removeEventListener("resize", handleGridHeight);
    };
  }, []);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?.clientHeight || 0) - 72);
  }

  useEffect(() => {
    if(saleReportsResult && saleReportsResult.data){
      const dt = JSON.parse(saleReportsResult.data);
      if(dt && dt.length){
        // if(dt[0].Priority){
          setPriority(dt);
        // }
        // else{
        //   setDataLoaded(dt);
        //   getColumns(dt[0]);
        // }
      }
    }
  }, [saleReportsResult]);

  const loadDataImport=(tableName)=>{
    getSaleReports({"ReportID": tableName, "Code": 0});
    setOpenImport(tableName);
  }

  const getColumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        resizable: true,
        hide: (key == 'CODE' ? true : false),
        cellStyle: () => ((key=="RSP" || key=="StockInWH" || key=="StockInStore" || key=='DiscountCCS')
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="SuggestOrderWH" ? "bold" : ""
        }:null),
        width: (key == "DESC" || key == 'Store' ? 300 : 150),
        cellRenderer: (props) => //(key == "LINK" ? CustomCell(props) : 
          (key=="RSP" || key=="StockInWH" || key=="StockInStore")?new Intl.NumberFormat('en-US').format(props.value)
          : key=='DiscountCCS' ? `${props.value} %` : props.value
      }
    });
    setCoumns(cols);
  }

  const CustomCell = (props) => {
    if(!props.data.CODE || props.data.CODE == '-1')
      return '';
    const handleClick = () => {
      setSelectedRecord(props.data);
      const encodedString = btoa(props.data.CODE);
      setOpenOtp(props.data.LINK + encodedString);
      setQrSrc(null);
    };
    const encodedString = btoa(props.data.CODE);
    return <Button onClick={handleClick}>{props.data.LINK}{encodedString}</Button>;
  };

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
    updatePinnedBottomRow(params.api); // Initial calculation
  }, []);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    
    const onlyNumbers = file.name.replace(/[^0-9]/g, '');
    const launchMonth = onlyNumbers.substring(0, 6);
    if (file) {
      setDataLoaded([]);
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, {
          //range: 0,
          raw: false,
          dateNF: "yyyy-mm-dd"
        });
        
        let count_zero = 0;
        const filtered = json.map(row => {
          if (!row || typeof row !== 'object') return null;
          const keys = Object.keys(row);
          count_zero += (String(row[keys[0]] || '').trim() && String(row[keys[1]] || '').trim()) ? 
                        (String(row[keys[3]] || '').trim() > 0 ? 0 : 1) : 0;
          return {
            BtqCode: String(row[keys[0]] || '').trim(),
            Barcode: String(row[keys[1]] || '').trim(),
            Style: String(row[keys[2]] || '').trim(),
            Qty: String(row[keys[3]] || '').trim()
          };
        }).filter(row => row.BtqCode && row.Barcode && row.Qty > 0);

        setDataLoaded(filtered);
        filtered.length > 0 &&
          getColumns(filtered[0]);

        setEnableSave(true);

        updatePinnedBottomRow(gridRef.current, filtered);

        if(count_zero > 0)
          setSnackContent("File import Có sản phẩm không có số lượng!");
      };
      reader.readAsArrayBuffer(file);

      event.target.value = '';
    }
  };

  const onSave = async() =>{
		setLoading(true);
    try {
      setConfirm(false);
			const formData = new FormData();
      formData.append("table", 'transfer_temp');
			formData.append("data", JSON.stringify(dataLoaded));
			const dt = await saveImportStatus(formData).unwrap();
			if(dt.length > 0){
        setSnackContent("Có lỗi khi lưu, vui lòng kiềm tra lại!");
        getColumns(dt[0]);
        setDataLoaded(dt);
        setEnableSave(false);
      }
      else{
        setSnackContent(`Đã cập nhật ${dataLoaded.length} dòng!`);
				setDataLoaded([]);
      }
    } catch (err) {
      setSnackContent("Lỗi kết nối!");
      console.error(err);
    }
		setLoading(false);
  }

  const updatePinnedBottomRow = (api, data) => {
    let Qty = 0;
    if(data)
      data.map(m=>{
        Qty += parseInt(m.Qty);
      })
    else
      api.forEachNodeAfterFilter((node) => {
          Qty += node.data.Qty;
      });
    setPinnedBottomRowData([{ make: 'Total', model: '', Qty: Qty }]);
  };

  const exportToCSV = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(dataLoaded);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    saveAs(data, "ItemTransfers.xlsx");
  }

  return (
    <div style={{padding: '0 10px'}}>
      { saleReportsResult.isLoading && <LoadingPage /> }
      <div style={{marginTop: '20px'}}>
        <div id='divHeader'>
          <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} ref={fileInputRef} style={{display: 'none'}} />
          <Button variant="contained" onClick={()=>fileInputRef.current.click()}
            sx={{ marginRight: '10px' }}>Select File</Button>
          <Button variant="contained" onClick={()=>onSave()} disabled={!enableSave}
            sx={{ marginRight: '10px' }}>Save Transfer</Button>
          <Button variant="contained" color="warning" onClick={(e)=>loadDataImport('btq_priority')}
            sx={{ marginRight: '10px' }}>Import Priority</Button>
          <Button variant="contained" color="warning" onClick={(e)=>loadDataImport('btq_items')}
            sx={{ marginRight: '10px' }}>Import Store Master</Button>
          <Button variant="contained" color="warning" onClick={(e)=>loadDataImport('PLC')}
            sx={{ marginRight: '10px' }}>Import PLC</Button>
          <Button onClick={exportToCSV} variant="contained" sx={{ flexShrink: 0 }}>
            EXPORT
          </Button>
        </div>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
          />
        </Paper>
      </div>

      <ImportExcel open={openImport} setOpen={setOpenImport} priority={priority} />

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}